import React, { useEffect, useRef, useState } from "react";
// import { PieChart, Pie, Cell, Tooltip } from "recharts";
import { DotLoader } from "react-spinners";
import { Wrapper, KatalkViewBox, ContentsBox } from "./styles";
import DataTable from "./DataTable";
import CustomButtons from "./CustomButtons";
import Header from "../Common/Header";

interface Date {
    year: number;
    month: number;
    day: number;
    date: number;
}
interface Message {
    date: Date;
    message: string;
}
interface User {
    Enter: string;
    Left: string;
    Messages: Array<Message>;
    isBanned: boolean;
}

const KaTalkView = () => {
    const [loading, setLoading] = useState(false);
    const [filename, setFilename] = useState('');
    const [data, setData] = useState({} as {[nickname: string]: User});
    const [displayData, setDisplayData] = useState([] as Array<{[nickname: string]: User}>);
    // const [chartData, setChartData] = useState([] as Array<{name: string, value: number}>);
    const fileRef = useRef<HTMLInputElement>(null);
    const ProcessLines = (lines: Array<string>) => {
        return new Promise<{[nickname: string]: User}>((resolve, reject) => {
            // const header = lines.slice(0, 2);
            const content = lines.slice(2);
            interface DateStr2NumProps {[key: string]: number}
            interface DateNum2StrProps {[key: number]: string}
            const DateStr2Num: DateStr2NumProps = {
                '월요일': 0 , '화요일': 1 , '수요일': 2 , '목요일': 3, '금요일': 4, '토요일': 5, '일요일': 6
            };
            const DateNum2Str: DateNum2StrProps = {
                0 : '월요일', 1 : '화요일', 2 : '수요일', 3 : '목요일', 4: '금요일', 5:  '토요일', 6:  '일요일'
            };
            interface currentProps {year: number, month: number, day: number, date: number}
            let current = {
                year: -1,
                month: -1,
                day: -1,
                date: -1,
            };
            let currentMsg = {
                nickname: '',
                time: '',
                msg: ''
            }
            const date2str = (current: currentProps) => {return `${current.year}년 ${current.month}월 ${current.day}일 ${DateNum2Str[current.date]}`};
            let _data = {} as {[nickname: string]: User};
            content.forEach((line, idx) => {
                if(line === '') return;

                const dateMatch = line.match(/(\d{4})년 (\d{1,2})월 (\d{1,2})일 ([가-힣]+)/);
                if(dateMatch) {
                    const year = Number(dateMatch[1]); const month = Number(dateMatch[2]); const day = Number(dateMatch[3]); const date = DateStr2Num[dateMatch[4]]
                    current.year = year; current.month = month; current.day = day; current.date = date;
                    return;
                }

                const msgMatch = line.match(/\[(.+)\] \[(.+)\] (.+)/);
                if(msgMatch) {
                    const nickname = msgMatch[1]; const time = msgMatch[2]; const msg = msgMatch[3];

                    if(Object.keys(_data).includes(nickname)) {
                        _data = {
                            ..._data,
                            [nickname]: {
                                ..._data[nickname],
                                Messages: [
                                    ..._data[nickname].Messages,
                                    {
                                        date: current, message: msg
                                    }
                                ]
                            }
                        }
                    }
                    else {
                        _data = {..._data, [nickname]: {isBanned: false, Enter: '', Left: '', Messages: [{date: current, message: msg}]}}
                    }
                    currentMsg.nickname = nickname; currentMsg.time = time; currentMsg.msg = msg;
                    return;
                }

                const enterMatch = line.match(/(.+)님이 들어왔습니다./);
                if(enterMatch) {
                    const nickname = enterMatch[1];
                    _data = {..._data, [nickname]: {isBanned: false, Enter: date2str(current), Left: '', Messages: []}};
                    return;
                }

                const leftMatch = line.match(/(.+)님이 나갔습니다./);
                if(leftMatch) {
                    const nickname = leftMatch[1];
                    if(Object.keys(_data).includes(nickname)) {
                        if(Object.keys(_data[nickname]).includes("Messages"))
                            _data = {..._data, [nickname]: {..._data[nickname], Left: date2str(current)}};
                        else
                            _data = {..._data, [nickname]: {..._data[nickname], Left: date2str(current), Messages: []}};
                    }
                    else {
                        _data = {..._data, [nickname]: {..._data[nickname], Left: date2str(current), Messages: []}};
                    }
                    return;
                }

                const outMatch = line.match(/(.+)님을 내보냈습니다./);
                if(outMatch) {
                    const nickname = outMatch[1];
                    if(Object.keys(_data).includes(nickname)) {
                        if(Object.keys(_data[nickname]).includes("Messages"))
                            _data = {..._data, [nickname]: {..._data[nickname], isBanned: true, Left: date2str(current)}};
                        else
                            _data = {..._data, [nickname]: {..._data[nickname], isBanned: true, Left: date2str(current), Messages: []}};
                    }
                    else {
                        _data = {..._data, [nickname]: {..._data[nickname], isBanned: true, Left: date2str(current), Messages: []}};
                    }
                    return;
                }

                if (currentMsg.nickname !== '') {
                    const lastIdx = _data[currentMsg.nickname].Messages.length - 1;
                    const msg = _data[currentMsg.nickname].Messages[lastIdx].message + line;
                    _data = {
                        ..._data,
                        [currentMsg.nickname]: {
                            ..._data[currentMsg.nickname],
                            Messages: [
                                ..._data[currentMsg.nickname].Messages.slice(0, lastIdx),
                                {
                                    ..._data[currentMsg.nickname].Messages[lastIdx], message: msg
                                }
                            ]
                        }
                    }
                }

                return;
            });

            resolve(_data)
        })
    };
    const ReadFile = (file: any) => {
        const reader = new FileReader();

        setLoading(true);
        reader.onload = () => {
            if(!reader.result) return
            const result = reader.result as string;
            const lines = result.split('\n');

            ProcessLines(lines)
            .then((_data) => {
                setData(_data);
            })
            .finally(() => {
                setLoading(false);
            })
        }

        reader.readAsText(file, 'utf-8');
    };
    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if(e.target.files?.length === 0) {
            setFilename('');
            return;
        }
        const files = e.target.files;
        if(files) {
            setFilename(files[0].name);
            ReadFile(files[0]);
        }
    }
    const onUpload = (e: React.MouseEvent<HTMLButtonElement>) => {
        fileRef.current?.click();
    }
    const onClear = (e: React.MouseEvent<HTMLButtonElement>) => {
        console.log('onClear')
        if(fileRef.current !== null) fileRef.current.files = null;
    }
    useEffect(() => {
        if(Object.keys(data).length === 0) return;

        // Default : Messages Length Sort
        const _displayData: Array<{[nickname: string]: User}> = Object.keys(data).map((key) => {return {[key]: data[key]}});
        const result = _displayData.sort((a, b) => b[Object.keys(b)[0]].Messages.length - a[Object.keys(a)[0]].Messages.length);
        // const _chartData = Object.keys(data).map((key) => {return {name: key, value: data[key].Messages.length}});
        // setChartData(_chartData);
        setDisplayData(result)
    }, [data])
    return (
        <Wrapper>
            <Header />
            <KatalkViewBox>
                <CustomButtons
                    filename={filename}
                    fileRef={fileRef}
                    handleFileChange={handleFileChange}
                    onUpload={onUpload}
                    onClear={onClear} />
                <ContentsBox>
                    {
                        /* <PieChart width={800} height={800}>
                            <Pie data={chartData} dataKey="value" fill="#82ca9d">
                            </Pie>
                            <Tooltip />
                        </PieChart> */
                    }
                    {
                        loading ? <DotLoader className="loading" /> :
                        <DataTable displayData={displayData} />
                    }
                </ContentsBox>
            </KatalkViewBox>
        </Wrapper>

    );
};

export default KaTalkView;